import router from '@/router'
import store from '../store'

import axios from 'axios'
import { apiConfig } from '@/config'

axios.defaults.baseURL = apiConfig.FACTORYBASE_API_URI
axios.defaults.timeout = apiConfig.TIMEOUT

const token = localStorage.getItem('token')

if (token) {
    axios.defaults.headers.common['Authorization'] = `JWT ${token}`
}

axios.interceptors.request.use(
    response => {
        if (!response.url.includes('token')) {
            store.dispatch('inspectToken')
        }

        return response
    },
    error => {
        return Promise.reject(error)
    }
)

axios.interceptors.response.use(
    response => {
        return response
    },
    error => {
        if (typeof error.response !== 'undefined') {
            switch (error.response.status) {
                case 401:
                    store.dispatch('logout')
                    router.push({ name: 'userLogin' })
                        .catch(() => {})
                    store.dispatch('showNotification', {
                        type: 'error',
                        message: 'Twoja sesja wygasła.',
                    })
                    break
            }
        }

        return Promise.reject(error)
    }
)

export function handleApiError(error, defaultMessage = 'Nieokreślony błąd aplikacji.') {
    if (error.response && error.response.status === 401) return

    if (error.response && error.response.data && error.response.data.errorCode !== undefined) {
        const errorCodes = store.state.common.errorCodes,
            errorMessage = errorCodes.find(
                item => item.code == error.response.data.errorCode
            )

        store.dispatch('showNotification', {
            type: 'error',
            message: errorMessage ? errorMessage.description : defaultMessage,
        })
    } else if (error.response && error.response.data && error.response.status === 403) {
        store.dispatch('showNotification', {
            type: 'error',
            message: error.response.data.detail ? error.response.data.detail : defaultMessage
        })
    } else if (error.response && error.response.data && error.response.data.error) {
        store.dispatch('showNotification', {
            type: 'error',
            message: error.response.data.error,
        })
    } else if (error.code === 'ECONNABORTED' || error.message === 'Network Error') {
        store.dispatch('showNotification', {
            type: 'error',
            message: 'Wystąpił błąd. Brak odpowiedzi serwera lub problemy z siecią.',
        })
    } else {
        store.dispatch('showNotification', {
            type: 'error',
            message: defaultMessage,
        })
    }
}
